var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCompCol3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "79px",
    viewBox: "0 0 64 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0457545455 63.9955925 0.0457545455 63.9955925 41.9999364 0 41.9999364"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search-software-supplier",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing",
    transform: "translate(-730.000000, -1466.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(730.000000, 1466.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#F6F4F0",
    cx: 32,
    cy: 31,
    r: 31
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.2745098e-05,22.6169364 C4.91507451,15.3159364 9.82989804,8.0143 14.7447216,0.7133 C14.2487216,4.38416364 15.3982118,7.25257273 18.4168784,9.5018 C17.0214275,11.6186636 15.651702,13.6963909 14.3462902,15.6767545 C19.0844863,14.5348 23.8142118,13.3953909 28.4532706,12.2773 C27.7765647,11.6807091 26.8598588,10.8715727 25.7511529,9.89348182 C28.7538196,8.31561818 30.1288784,5.97348182 30.2910745,2.77734545 C30.320251,2.20175455 31.3335843,1.24434545 31.8869961,1.2488 C32.4589176,1.25293636 33.4559373,2.16611818 33.520251,2.76398182 C33.8575059,5.90157273 35.2008784,8.29875455 38.1931922,9.96920909 C37.1566431,10.8925727 36.2650353,11.6864364 35.5676235,12.3078455 C40.1304471,13.3995273 44.8542118,14.5297091 49.6567216,15.6789818 C48.3434667,13.7107091 46.9646431,11.6447545 45.5142902,9.47157273 C48.5050353,7.20484545 49.6375843,4.2203 48.6879373,0.0457545455 C49.2476235,0.795390909 49.5535059,1.17116364 49.8233098,1.57175455 C54.1530353,8.0038 58.4799373,14.4380727 62.803702,20.8742545 C64.2575059,23.0388455 64.3707608,24.6456636 63.2015059,26.2515273 C62.0099765,27.8879364 60.3334275,28.2551182 57.8656627,27.4074818 C53.7894275,26.0068455 49.7147608,24.6008 45.397898,23.1139364 L45.397898,41.9999364 L18.5746824,41.9999364 L18.5746824,23.1422545 C16.5586824,23.8241182 14.755702,24.4296182 12.9555451,25.0446636 C10.7349961,25.8032091 8.51632941,26.5681182 6.29797647,27.3323909 C3.0713098,28.4444364 1.63413333,27.8882545 -6.2745098e-05,24.8906636 L-6.2745098e-05,22.6169364 Z",
    id: "Fill-1",
    fill: "#002452",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41,6.67420887 C39.6940266,6.7348845 38.3238097,6.55026185 37.1137359,6.92664546 C35.9852855,7.27739605 35.0262889,8.22484445 33.8565613,9 L30.4575544,9 C29.1972032,6.26375605 26.5033226,6.75273028 24,6.75370368 C24.0980721,3.37533632 27.8729188,0.236102341 32.0090185,0.0128679248 C36.3691945,-0.223020768 40.5152256,2.8140056 41,6.67420887 L37.1137359,14.0000137",
    id: "Fill-4",
    fill: "#002452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6270786,14.0064362 C25.6323942,12.3607721 24.3034985,11.124445 22.5247508,11.1195024 C20.7619979,11.1145889 19.3921156,12.3647762 19.3860979,13.9833359 C19.3801196,15.6028197 20.7436706,16.8690232 22.4987594,16.8748938 C24.26851,16.8804193 25.6220643,15.6394722 25.6270786,14.0064362 M22.5357472,8.00002735 C26.1598872,8.01021897 28.9902886,10.6267109 28.9999761,13.9747118 C29.0096155,17.3827735 26.1039056,20.0386899 22.4081225,19.9995734 C18.8456289,19.961997 15.9702424,17.2410917 16.0002325,13.9359034 C16.0305558,10.631023 18.9382651,7.99019872 22.5357472,8.00002735",
    id: "Fill-6",
    fill: "#002452"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6301027,14.0272138 C44.6470988,12.3843878 43.3204045,11.1320216 41.5488127,11.1187805 C39.7842192,11.1058473 38.4038706,12.3468199 38.3865413,13.9619319 C38.3692119,15.5825866 39.7219003,16.8568161 41.477829,16.8740604 C43.2454217,16.8916126 44.6134399,15.6561828 44.6301027,14.0272138 M41.5478129,8.00001422 C45.1636464,8.00649511 47.9963271,10.6344009 48,13.9850269 C48.0036587,17.3298022 45.1626467,19.9860378 41.5671418,19.9999476 C37.8999867,20.0137518 34.964663,17.298085 35.0003215,13.9252877 C35.0356467,10.6211597 37.9396442,7.99294603 41.5478129,8.00001422",
    id: "Fill-8",
    fill: "#002452"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCompCol3Icon);
export default __webpack_public_path__ + "static/media/add-comp-col3-icon.9496c741e532c1cd14587160090232fa.svg";
export { ForwardRef as ReactComponent };